"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeEightBlogSectionGeneratedProps = {
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "Our Updated" */
    sectionDiv0H20H2Text?: ReactNode;
    sectionDiv0H20H2Visible?: boolean;
    sectionDiv0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "banner-icon" */
    sectionDiv0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-six-img4.jpg" */
    sectionDiv0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Blogs & Articles" */
    sectionDiv0H20Span1SpanText?: ReactNode;
};

const HomeEightBlogSectionGenerated: FC<HomeEightBlogSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0H20H2Text = "Our Updated",
    sectionDiv0H20H2Visible,
    sectionDiv0H20H2Renderer,
    sectionDiv0H20H2Props,
    sectionDiv0H20Span0ImageWithBasePath0ImageAlt = "banner-icon",
    sectionDiv0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-six-img4.jpg",
    sectionDiv0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0H20Span1SpanText = "Blogs & Articles",
}) => {
    return (
        <section className="blog-section-eight section wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="section-header section-header-eight text-center">
                {renderNode(sectionDiv0H20H2Visible, sectionDiv0H20H2Renderer, (
                    <h2 className="section-title" {...(sectionDiv0H20H2Props ?? {})}>
                        {sectionDiv0H20H2Text}
                        <br />
                        {" "}
                        <span className="img-container">
                            {renderNode(sectionDiv0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0H20Span0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </span>
                        <span className="text-gradient">{sectionDiv0H20Span1SpanText}</span>
                    </h2>
                ))}
            </div>
            <div data-template-tag="BlogSliderEight" />
        </section>
    );
};

export default HomeEightBlogSectionGenerated;
